import { render, staticRenderFns } from "./AddMiniProject.vue?vue&type=template&id=aa061644&scoped=true"
import script from "./AddMiniProject.vue?vue&type=script&lang=js"
export * from "./AddMiniProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa061644",
  null
  
)

export default component.exports